import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        '&.MuiBackdrop-root': {
            background: 'none',
        },
    },
    container: {
        '&.MuiDialog-container': {
            height: ({ height }) => (height ? height : '100%'),
            // fix issue of scroll for template
            paddingBottom: ({ paddingBottom }) =>
                paddingBottom ? `${paddingBottom} !important` : '0px !important',
            outline: 0,
            position: 'absolute',
            bottom: 0,
            right: ({ right }) => right,
            width: ({ width }) => (width ? width : '100%'),
            background: ({ backdrop }) => backdrop,
        },
    },

    paperFullScreen: {
        '&.MuiDialog-paperFullScreen': {
            background: ({ background }) =>
                background ? background : '#f5f5f5',
            borderTopLeftRadius: ({ borderTopLeftRadius }) =>
                borderTopLeftRadius ? borderTopLeftRadius : '20px',
            borderTopRightRadius: ({ borderTopRightRadius }) =>
                borderTopRightRadius ? borderTopRightRadius : '20px',
            marginTop: ({ marginTop }) => (marginTop ? marginTop : '16rem'),
            overflowX: ({ overflowX }) => (overflowX ? overflowX : 'unset'),
            height: ({ height }) => height,
            ['@media (max-width:576px)']: {
                paddingBottom: ({ mbPaddingBottom }) => (mbPaddingBottom ? mbPaddingBottom : '0px'),
                height: ({ mobilePaperFullScreenHeight }) =>
                    mobilePaperFullScreenHeight,
            },
        },
    },
}));

export const TemplateDetailsContainer = styled.div.attrs(props => ({
    id: props.id || 'modal-dialog'
}))`
    .web {
        display: block;

        ${({ isIPadPotrait }) =>
            isIPadPotrait &&
            css`                
                @media only screen and (min-device-width: 768px) and (max-device-width: 850px) and (orientation: portrait) {
                    display: none;
                }
                ${media.smalDevice`
                    display: none;
                `}
            `}
        ${media.mobileDevice`
         display: none;
        `}
    }

    .mobile {
        display: none !important;
        ${media.mobileDevice`
         display: block;
        `}
    }
    .dialog {
        display: none !important;
background-color : ${({ backgroundColor }) => (backgroundColor ? backgroundColor : 'none')};
        ${({ isIPadPotrait }) =>
            isIPadPotrait &&
            css`
                @media only screen and (min-device-width: 768px) and (max-device-width: 850px) and (orientation: portrait) {
                    display: block;
                }
                ${media.smalDevice`
                    display: block;
                `}
            `}

        ${media.mobileDevice`
         display: block;
        `}
    }
`;
